/**
 * 获取短信验证码间隔时间
 */
export const IDENTITY_CODE_TIME = 59

/**
 * 注册和找回密码页面类型
 */
export const PAGE_TYPE = {
  CHECK_IDENTITY_CODE: 1,
  CONFIRM_PASSWORD: 2,
  AGREEMENT: 3,
  PRIVATE: 4,
}

export const NEED_BAND_STORAGE_KEY = 'need_band_show'
